/**
 * Adapptio Core library.
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export const ACCOUNT = {
	CACHE: {
		EXPIRES_IN_MILLISECONDS: 5 * 60 * 1000,
		MAX_READ_COUNT: 100
	}
};
